module.exports = __webpack_public_path__ + "img/garantie.89326250.svg";